require("core-js/modules/es.number.constructor");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.videoCourse = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var _default = {
    name: "VideoCourse",
    data: function data() {
      return {
        meta: {
          title: '安装教程'
        }
      };
    },
    created: function created() {
      var vm = this; // 不同的安装设备类型
      // 1:750W增氧机 2:370W增氧机
      // 3: 1.5KW增氧机

      var type = vm.$route.query.type;

      if (Number(type) < 3 && Number(type) > 0) {
        window.location.href = 'https://iot.tool.yudada.com/webview/installationVideo.html?type=1';
      }

      if (Number(type) == 3) {
        window.location.href = 'https://iot.tool.yudada.com/webview/installationVideo.html?type=3';
      }

      if (Number(type) == 4) {
        window.location.href = 'https://iot.tool.yudada.com/webview/installationVideo.html?type=4';
      }
    },
    methods: {}
  };
  _exports.default = _default;
});